import * as React from 'react';
import { UIHeading2, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';
import { PropsWithChildren } from 'react';
import { UIText1 } from '@cian/ui-kit/typography';

import styles from './styles.css';

interface IFormProps extends PropsWithChildren {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}

export const FormWrapper: React.FC<IFormProps> = ({ title, children, subtitle }) => {
  const deviceType = useDeviceType();

  return (
    <form className={cn(styles['form'], styles[deviceType])} data-testid="leave-contacts-modal-form">
      <div className={styles['form-title']}>
        <UIHeading2 whiteSpace="pre-line">{title}</UIHeading2>
        {subtitle && (
          <UIText1 color="gray60_100" whiteSpace="pre-line">
            {subtitle}
          </UIText1>
        )}
      </div>
      {children}
    </form>
  );
};
